[
    {
        "institution": "Microsoft",
        "keywords": [
            "Large Language Models",
            "Games"
        ],
        "role": "Research Intern under Nebojsa Jojic",
        "description": "Developed games using LLMs and methods for eliciting errors from LLMs",
        "location": "Redmond, WA",
        "startDate": "Summer 2023"
    },
    {
        "institution": "DeepMind",
        "keywords": [
            "Deep RL",
            "Foundation Models",
            "In-context Learning"
        ],
        "role": "Research Intern under Volodymyr Mnih",
        "description": "Performed research into in-context learning of world models for reinforcement learning.",
        "location": "London, UK",
        "startDate": "Fall 2022"
    },
    {
        "institution": "University of Michigan",
        "keywords": [
            "MuJoCo",
            "Robotics",
            "Deep RL"
        ],
        "role": "Research Engineer under Satinder Singh",
        "description": "Developed robotics simulations using MuJoCo simulation software and applied on-policy and off-policy reinforcement learning algorithms in order to master navigation and grasping tasks. [Click for video.](https://www.youtube.com/watch?v=EjhcR-CealU)",
        "location": "Ann Arbor, MI",
        "startDate": "Fall 2017"
    },
    {
        "institution": "Google",
        "keywords": [
            "Data Science",
            "Machine Learning"
        ],
        "role": "Intern with Android Location and Context Team",
        "description": "Applied machine learning to battery optimization in Android devices.",
        "location": "Mountain View, CA",
        "startDate": "Summer 2017"
    },
    {
        "institution": "Georgia Tech Research Institute",
        "keywords": [
            "Robotics",
            "Gazebo",
            "Reinforcement Learning"
        ],
        "role": "Research Intern",
        "description": "Worked on applying policy-gradient algorithms and other reinforcement learning techniques to the problem of quadcopter navigation. Developed a system for running multiple headless Gazebo processes in parallel.",
        "location": "Atlanta, GA",
        "startDate": "Spring 2017"
    },
    {
        "institution": "Apple",
        "keywords": [
            "Natural Language Processing",
            "Deep Learning"
        ],
        "role": "Intern with Siri Natural Language Team",
        "description": "Worked on machine learning techniques for deriving meaning from user utterances.",
        "location": "Cupertino, CA",
        "startDate": "Summer 2016"
    },
    {
        "institution": "United States Marine Corps",
        "keywords": [],
        "role": "Intelligence Officer (Rank: Captain)",
        "description": "Led the intelligence section at a Marine Corps Logistics Battalion, mentoring the Marines who worked with me, developing new capabilities within the section, and planning battalion training in conjunction with adjacent sections.",
        "startDate": "2010",
        "endDate": "2015"
    }
]
